// removed by extract-text-webpack-plugin
module.exports = {"s":"src-components-modules-Header-HeaderNav-style----colsizes-module---s---Iv7hv","m":"src-components-modules-Header-HeaderNav-style----colsizes-module---m---nmqmJ","l":"src-components-modules-Header-HeaderNav-style----colsizes-module---l---3uwKr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Header/HeaderNav/style/colsizes.module.css
// module id = 1463
// module chunks = 168707334958949